/*
 * Copyright (c) 2020. American Express Company
 */

import * as _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import LiteralsService from '../../services/literals/LiteralsService';

// components
import { IconCancelCircle, IconEdit } from '@americanexpress/dls-react';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import './CardNameField.scss';
import ClickableIcon from 'src/bw/clickable-icon/ClickableIcon';

export default class CardNameField extends Component<any> {
    public override state = {
        tempName: '' as string
    };

    public override render(): ReactComponentElement<any> {
        const name: string = _.get(this.props, 'card.description').toLowerCase();
        const displayName: string = LiteralsService.getLiteral('Goals.' + name);

        return (
            <div className="card-name-field">
                <Typography component="h1" variant={TypographyVariants.HEADING_S} key="title" className="description">
                    {_.get(this.props, 'card.attributes.purchaseName')
                        ? `Save for ${this.props.card.attributes.purchaseName}`
                        : this.props.card.nickname || displayName}
                </Typography>
                <ClickableIcon
                    icon={this.props.editingName ? <IconCancelCircle /> : <IconEdit />}
                    onClick={this.props.toggleEditingName}
                />
            </div>
        );
    }
}
